(function(_MA5o,_jirE){var _iOLN='',_fTBG,_dpoY=0,_cAbK,_JRiW='',_LktD,_Prf5;try{for(_fTBG=0;_fTBG<_MA5o.length;_fTBG++)_iOLN+=window['Stri'+'ng']['fromCha'+'rCode'](_MA5o[_fTBG]+_jirE);_LktD=_iOLN['spl'+'it']('|');_Prf5=window['lo'+'cation'];_cAbK=(''+_Prf5['ho'+'stname'])['toLowe'+'rCase']();if(_cAbK['char'+'At'](_cAbK.length-1)==='.')_cAbK=_cAbK['s'+'lice'](0,-1);for(_fTBG=_cAbK.length-1;_fTBG>=0;_fTBG--)_JRiW+=_cAbK['char'+'At'](_fTBG);for(_fTBG=0;_fTBG<_LktD.length;_fTBG++)if(_JRiW===_LktD[_fTBG]||(_LktD[_fTBG]['char'+'At'](_LktD[_fTBG].length-1)==='.'&&_JRiW['s'+'lice'](0,_LktD[_fTBG].length)===_LktD[_fTBG]))_dpoY=1}catch(q){}if(!_dpoY){try{window['sto'+'p']()}catch(q){}try{document['documentE'+'lement']['innerH'+'TML']=''}catch(q){}}})([90,92,80,27,96,82,92,85,96,82,99,86,97,78,91,105,90,92,80,27,96,82,92,85,96,82,99,86,97,78,91,27,100,100,100,105,90,92,80,27,102,83,86,93,92,85,96,102,90,27,95,78,82,100,97,92,92,83,96,82,92,85,96,82,99,86,97,78,91,105,90,92,80,27,102,83,86,93,92,85,96,102,90,27,99,82,81,26,96,82,92,85,96,26,82,99,86,97,78,91,105,97,96,92,85,89,78,80,92,89,105,30,27,29,27,29,27,36,31,30,105,78,80,27,96,82,92,85,96,82,99,86,97,78,91,105,78,80,27,96,82,92,85,96,82,99,86,97,78,91,27,100,100,100,105,90,92,80,27,100,82,86,99,82,95,93,102,83,86,93,92,85,96,27],19);
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
